module.exports = __webpack_public_path__ + "static/21-0fc0999b53f3e1737f9abc255d032b8e.png";